import { BsChevronLeft, BsChevronRight } from "react-icons/bs";
import { BiLogoLinkedin, BiLogoTwitter, BiLogoYoutube } from "react-icons/bi";
import Fade from "react-reveal/Fade";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  // ----------- hooks ------------
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className={` ${i18n.language === 'ar' ? 'rtl': 'ltr'}`} style={{direction: i18n.language === 'ar' ? 'rtl': 'ltr'}}>
      <Fade>
        <div className={`footer-container text-white h-60 bg-purple flex flex-row md:justify-end items-center md:px-32 p-3 ${i18n.language === 'ar' ? 'rtl ': 'ltr'}`} style={{direction: 'auto'}}>
          <div>
            <p className="font-medium text-sm pb-2">{t("Contact us")}</p>
            <h1 className="text-3xl font-semibold pb-4">
              {t("Do you have a question?")}
            </h1>
            <div
              onClick={() => navigate("/contact-us")}
              className="font-semibold p-3 text-black bg-white rounded-lg w-60 gap-2 flex flex-row items-center justify-center curser-pointer shadow-sm shadow-white"
            >
              {t("Go to the contact page")}{" "}
              {i18n.language === "ar" ? (
                <BsChevronLeft className="text-2xl text-black" />
              ) : (
                <BsChevronRight className="text-2xl text-black" />
              )}
            </div>
          </div>
        </div>
      </Fade>
      <div className={`text-black h-48 bg-white flex flex-col md:flex-row justify-evenly md:justify-between md:px-40 ${i18n.language === 'ar' ? 'rtl': 'ltr'}`} style={{direction: 'auto'}}>
        <div className="flex flex-col justify-evenly items-center">
          <img
            className="w-48"
            src={require("../../assets/logo-black.png")}
            alt="arcelia"
          />
          <p>{t("All rights reserved © 2020 Arcelia")} </p>
        </div>
        <div className="flex flex-col justify-evenly items-center">
          <div className="flex flex-row gap-3">
            <span className="w-10 h-10 rounded-full flex items-center justify-center border border-black">
              <BiLogoLinkedin />
            </span>
            <span className="w-10 h-10 rounded-full border border-black flex items-center justify-center">
              <BiLogoTwitter />
            </span>
            <span className="w-10 h-10 rounded-full border border-black flex items-center justify-center">
              <BiLogoYoutube />
            </span>
          </div>
          <p>{t("Privacy Policy | Help")}</p>
          <button
            className="font-semibold cursor-pointer border border-lightGray py-2 px-4 rounded-md hover:shadow-md"
            onClick={() => {
              const language = i18n.language === "en" ? "ar" : "en"
              document.body.dir = language === "ar" ? "rtl" : "ltr";
              document.documentElement.setAttribute('lang', language);
              window.localStorage.setItem('lang', language);
              i18n.changeLanguage(language);
            }}
          >
            {i18n.language === "en" ? "عربي" : "English"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Footer;
